(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc9-01-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('.rvx-mini-review-slot').forEach(slot=>{if(slot.dataset.ready)return;slot.dataset.ready='1';const cards=[...slot.querySelectorAll('[data-rvx-slide]')];const out=slot.querySelector('output');let n=0;const show=()=>{cards.forEach((c,i)=>c.hidden=i!==n);if(out)out.textContent=`${n+1} / ${cards.length}`};slot.querySelectorAll('button').forEach((b,i)=>b.addEventListener('click',()=>{n=(n+(i===0?-1:1)+cards.length)%cards.length;show()}));show()});const purchase=document.querySelector('#ridevra-offer');if(!purchase||purchase.dataset.ready)return;purchase.dataset.ready='1';const radios=[...purchase.querySelectorAll('input[name="id"]')];const price=()=>{const selected=radios.find(r=>r.checked);if(selected)document.querySelectorAll('[data-rvx-current-price]').forEach(e=>e.textContent=selected.dataset.price)};radios.forEach(r=>r.addEventListener('change',price));document.querySelectorAll('[data-rvx-pack]').forEach(a=>a.addEventListener('click',()=>{const r=radios.find(x=>x.dataset.rvxPackCount===a.dataset.rvxPack&&!x.disabled);if(r){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}}));const sticky=purchase.querySelector('.rvx-sticky-buy');const form=purchase.querySelector('form');if(sticky&&form){const observe=new IntersectionObserver(es=>{sticky.hidden=es[0].isIntersecting||form.getBoundingClientRect().top>0},{threshold:0});observe.observe(form);const update=()=>{const r=form.getBoundingClientRect();sticky.hidden=r.bottom>0};window.addEventListener('scroll',update,{passive:true});update()}price()};document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);if(document.readyState!=='loading')init()})();
(()=>{const init=()=>document.querySelectorAll('[data-rvx-clips]').forEach(g=>{if(g.dataset.clipReady)return;g.dataset.clipReady='1';const track=g.querySelector('.rvx-clips__track'),prev=g.querySelector('[data-clip-prev]'),next=g.querySelector('[data-clip-next]');if(!track)return;const update=()=>{const max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2};const move=dir=>track.scrollBy({left:dir*(track.querySelector('article').getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(update);observer.observe(track);g.querySelectorAll('.rvx-clips__video').forEach(video=>{const button=video.parentElement.querySelector('button');button.addEventListener('click',()=>{video.controls=true;video.play().catch(()=>{button.hidden=false})});video.addEventListener('play',()=>{document.querySelectorAll('.rvx-clips__video').forEach(v=>{if(v!==video)v.pause()});button.hidden=true});video.addEventListener('ended',()=>{button.hidden=false});video.addEventListener('pause',()=>{button.hidden=false})});update()});document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);if(document.readyState!=='loading')init()})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hc9-02-purchase"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>{document.querySelectorAll('.rvx-mini-review-slot').forEach(slot=>{if(slot.dataset.ready)return;slot.dataset.ready='1';const cards=[...slot.querySelectorAll('[data-rvx-slide]')];const out=slot.querySelector('output');let n=0;const show=()=>{cards.forEach((c,i)=>c.hidden=i!==n);if(out)out.textContent=`${n+1} / ${cards.length}`};slot.querySelectorAll('button').forEach((b,i)=>b.addEventListener('click',()=>{n=(n+(i===0?-1:1)+cards.length)%cards.length;show()}));show()});const purchase=document.querySelector('#ridevra-offer');if(!purchase||purchase.dataset.ready)return;purchase.dataset.ready='1';const radios=[...purchase.querySelectorAll('input[name="id"]')];const price=()=>{const selected=radios.find(r=>r.checked);if(selected)document.querySelectorAll('[data-rvx-current-price]').forEach(e=>e.textContent=selected.dataset.price)};radios.forEach(r=>r.addEventListener('change',price));document.querySelectorAll('[data-rvx-pack]').forEach(a=>a.addEventListener('click',()=>{const r=radios.find(x=>x.dataset.rvxPackCount===a.dataset.rvxPack&&!x.disabled);if(r){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}}));const sticky=purchase.querySelector('.rvx-sticky-buy');const form=purchase.querySelector('form');if(sticky&&form){const observe=new IntersectionObserver(es=>{sticky.hidden=es[0].isIntersecting||form.getBoundingClientRect().top>0},{threshold:0});observe.observe(form);const update=()=>{const r=form.getBoundingClientRect();sticky.hidden=r.bottom>0};window.addEventListener('scroll',update,{passive:true});update()}price()};document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);if(document.readyState!=='loading')init()})();
(()=>{const init=()=>document.querySelectorAll('[data-rvx-clips]').forEach(g=>{if(g.dataset.clipReady)return;g.dataset.clipReady='1';const track=g.querySelector('.rvx-clips__track'),prev=g.querySelector('[data-clip-prev]'),next=g.querySelector('[data-clip-next]');if(!track)return;const update=()=>{const max=track.scrollWidth-track.clientWidth;prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max-2};const move=dir=>track.scrollBy({left:dir*(track.querySelector('article').getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});const observer=new ResizeObserver(update);observer.observe(track);g.querySelectorAll('.rvx-clips__video').forEach(video=>{const button=video.parentElement.querySelector('button');button.addEventListener('click',()=>{video.controls=true;video.play().catch(()=>{button.hidden=false})});video.addEventListener('play',()=>{document.querySelectorAll('.rvx-clips__video').forEach(v=>{if(v!==video)v.pause()});button.hidden=true});video.addEventListener('ended',()=>{button.hidden=false});video.addEventListener('pause',()=>{button.hidden=false})});update()});document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);if(document.readyState!=='loading')init()})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
